module.exports = __webpack_public_path__ + "static/f-519caa72d2d7f420724f86f8e18136af.jpg";